import React from 'react';
import { users } from 'types';
import DialogConfirm from 'components/dialog/dialog-confirm';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import { CellButtonContentStyled } from '../index.styled';
import useUserActivate from '../hooks/use-user-activate';

const DialogActivate = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onActivate] = useUserActivate(asyncStatesHandlers);

    if (!data || !data.id) {
        console.error('No ID');
    }

    return (
        <DialogConfirm<users.TUsers>
            isDialogOpen={!!data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={<>Confirm user activate</>}
            labels={{
                onOk: (
                    <CellButtonContentStyled>
                        Activate user
                    </CellButtonContentStyled>
                ),
            }}
            onOk={async () => {
                if (!data || !data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onActivate({ id: data.id });
                } catch (e) {}
            }}
        />
    );
};

export default DialogActivate;
